import { EGarageKind } from '../../../../api-models/common/json_query';

export const GARAGE_KINDS_MAP_VALUE_TO_LABEL = {
  [EGarageKind.Builtin]: 'Встроенный',
  [EGarageKind.Capital]: 'Капитальный',
  [EGarageKind.Selfbuilt]: 'Самострой',
  [EGarageKind.Shell]: 'Ракушка',
};
